export default __webpack_public_path__ + "static/media/showroom_white_nonum.a8f1a441.png";